import { useEffect, useMemo, useState } from "react";
import InstructionService from "../../services/instructionService";
import EmptyBlock from "../emptyBlock";
import Input from "../UI/input";
import c from "./styles.module.scss";

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const InstructionItem = ({ instruction }) => {
  return (
    <a
      className={c.item}
      href={instruction.filePath}
      target="_blank"
      rel="noreferrer"
    >
      <span className={c.module}>{instruction.module}</span>
      <span className={c.action}>PDF</span>
    </a>
  );
};

const Instructions = () => {
  const [instructions, setInstructions] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const loadInstructions = async () => {
      try {
        const data = await InstructionService.getAll();
        setInstructions(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error(error);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    loadInstructions();
  }, []);

  const filteredInstructions = useMemo(() => {
    const query = normalize(search);

    if (!query) {
      return instructions;
    }

    return instructions.filter((instruction) =>
      normalize(instruction.module).includes(query),
    );
  }, [instructions, search]);

  return (
    <div className={c.instructions}>
      <div className={c.instructionsBanner} />
      <div className={c.description}>
        <p>
          У каждых часов Casio есть модуль - четырехзначный номер, по которому
          можно найти инструкцию к конкретной модели.
        </p>
        <p>
          Чтобы узнать модуль ваших часов, найдите четыре цифры на задней
          крышке корпуса. Обычно номер модуля указан в отдельной рамке.
        </p>
        <p>
          После этого вы можете найти нужную инструкцию на нашем сайте: через
          строку поиска или в списке модулей ниже.
        </p>
      </div>
      <div className={c.head}>
        <Input
          placeholder="Введите номер модуля"
          icon="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className={c.counter}>
          {filteredInstructions.length} из {instructions.length}
        </div>
      </div>

      {loading ? (
        <EmptyBlock text="Загружаем инструкции..." icon="loading" padding />
      ) : null}

      {!loading && error ? (
        <EmptyBlock text="Не удалось загрузить инструкции" padding />
      ) : null}

      {!loading && !error && !filteredInstructions.length ? (
        <EmptyBlock text="Инструкции не найдены" icon="search" padding />
      ) : null}

      {!loading && !error && filteredInstructions.length ? (
        <div className={c.list}>
          {filteredInstructions.map((instruction) => (
            <InstructionItem
              key={instruction.module}
              instruction={instruction}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default Instructions;
